import React, { useEffect, useState } from 'react'
import { getLoggedInUser, resetPassword } from '../axios';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import * as imagesdata from '../imagesdata'
import { motion } from "framer-motion";

const ResetPassword = () => {
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
        password: '',
        passwordAgain: ''
    });

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const [windowHeight, setWindowHeight] = useState(0);
    const [windowWidth, setWindowWidth] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordAgain, setShowPasswordAgain] = useState(false);

    const [isButtonDisable, setIsButtobDisable] = useState(false);

    function setPasswordHandler(evt) {
        setFormData({ ...formData, password: evt.target.value });
    }

    function setPasswordAgainHandler(evt) {
        setFormData({ ...formData, passwordAgain: evt.target.value });
    }

    const doResetPassword = (e) => {
        e.preventDefault();
        setIsButtobDisable(true)
        if (formData.password !== formData.passwordAgain) {
            toast.error("Girilen Şifreler Eşleşmiyor.")
            setIsButtobDisable(false)
            return
        }
        resetPassword(token, formData.password)
            .then((res) => {
                toast.success(res.data)
                window.location.href = '/giris-yap'
                setIsButtobDisable(false)
            })
            .catch((err) => {
                toast.error(err.response.data)
                setIsButtobDisable(false)
            })
    }

    useEffect(() => {
        console.log(isButtonDisable)
    }, [isButtonDisable]);

    const animations = {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
    };

    useEffect(() => {
        const handleResize = () => {
            const height = window.innerHeight;
            const width = window.innerWidth;
            if (window.innerHeight < 620) {
                setWindowHeight(620)
            }
            else {
                setWindowHeight(height)
            }
            setWindowWidth(width)
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const togglePW = () => {
        setShowPassword(!showPassword);
    };

    const togglePWA = () => {
        setShowPasswordAgain(!showPasswordAgain);
    };

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await getLoggedInUser();
                setUser(response.data)

            } catch (error) {
                setUser(null)
            }
        };
        checkAuth();
    }, []);


    if (user) {
        return window.location.href = '/';
    } else {
        return (
            <motion.div
                className="py-3"
                variants={animations}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 1 }}
            >
                <div className="wrapper" style={{ backgroundColor: "white", maxHeight: windowHeight - 1 }}>
                    <form onSubmit={doResetPassword} className='auth-form'>
                        <div className="login-options">
                            <div className="login-image-container" style={{
                                height: windowHeight < windowWidth - 500 ? windowWidth - 500 : windowHeight - 1,
                                width: windowWidth,
                                overflowY: 'hidden'
                            }}>
                                <img className="login-image" src={imagesdata.Auth} alt="Login" />
                            </div>
                            <div className="login-form" style={{ height: windowHeight }}>
                                <a href='/'><img src={imagesdata.TersLogo} alt="Logo" style={{ height: "69px", width: "200px", marginTop: "50px" }} /></a>
                                <h2><span>Şifre Yenileme</span></h2>
                                <div className="form-wrapper" >
                                    <label htmlFor="password">Yeni Şifre</label>
                                    <div className="input-eye-wrapper">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            name="password"
                                            value={formData.password}
                                            onChange={setPasswordHandler}
                                        />
                                        <div
                                            className={`eye ${showPassword ? '' : 'slash'}`}
                                            onClick={togglePW}
                                        >
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-wrapper" >
                                    <label htmlFor="password">Yeni Şifre Tekrar</label>
                                    <div className="input-eye-wrapper">
                                        <input
                                            type={showPasswordAgain ? 'text' : 'password'}
                                            className="form-control"
                                            name="password"
                                            value={formData.passwordAgain}
                                            onChange={setPasswordAgainHandler}
                                        />
                                        <div
                                            className={`eye ${showPasswordAgain ? '' : 'slash'}`}
                                            onClick={togglePWA}
                                        >
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <button className="auth-button button-submit" disabled={isButtonDisable} type="submit"> <span> Kaydet </span></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </motion.div>
        );
    }
}

export default ResetPassword